const certificates = {
	modulename: "Kompetanse",
	new_certificate: "Registrer kompetanse",
	edit_certificate: "Rediger: {name}",
	view_certificate: "Viser: {name}",
	list_title: "Kompetanse",
	list_subtitle: "Håndter kompetanse",
	create_title: "Opprett nytt kompetanse",
	update_title: "Endre kompetanse",
	address_title: "Adresse",
	details_title: "Sertifikat detaljer",
	id: "ID",
	title: "Tittel",
	company_name: "Sertifiseringsorgan",
	issued_date: "Utstedt dato",
	issued_by: "Opplæringsvirksomhet",
	issued_by_vat: "Utstedt av orgnr",
	course_name: "Kursnavn",
	course_held_by: "Instruktør",
	note: "Notat",
	course_id: "Kurs",
	class_id: "Klasser",
	participant_id: "Elever",
	drivingtest_id: "Oppkjøring",
	attendee_id: "Elev",
	documents: "Dokumenter",
	filename: "Filnavn",
	mime: "Mime",
	path: "Bane",
	size: "Størrelse",
	deleted_on: "Slettet",
	removed_on: "Fjernes",
	created_at: "Opprettet",
	upload_files: "Last opp",
	select_files: "Velg filer",
	save_first: "Vennligst lagre sertifikat før filopplasting.",
	title_tooltip: "Her kan du registrere kompetanse digitalt, som kommer enten fra andre virksomheter og/eller som ikke er tilgjengelig digitalt.",
	add_title: "Ny tittel",
	new_title_required: "Legg til ekstra tittel",
	moduletemplates: "Moduler",
	file_upload_note: "NB: Ved kompetansebevis/plastkort, husk å laste opp begge sider.",
};
export default certificates;